const airDropAbi = [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "nftContract",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Airdropped",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "nftContractAddress",
          type: "address",
        },
        {
          internalType: "address[]",
          name: "recipients",
          type: "address[]",
        },
        {
          internalType: "uint256[]",
          name: "tokenIds",
          type: "uint256[]",
        },
      ],
      name: "bulkAirdrop",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ];

  export default airDropAbi;